import { mergeStyleSets } from '@uifabric/merge-styles';

const photoUploaderClassNames = (): { [key: string]: string } => mergeStyleSets({
  image: <any>{
      objectFit: 'container'
  },
  label: ['ms-fontColor-themePrimary--hover', {
    display: 'flex',
    alignItems: 'center',
    selectors: {
      i: {
        fontSize: 32,
        marginRight: 8
      }
    }
  }],
  icon: ['ms-fontColor-themePrimary'],
  files: {
    display: 'none'
  }
});

export default photoUploaderClassNames;
